export default [
  {
    path: "/Empresas",
    name: "Empresas",
    component: () => import("../views/index"),
    meta: { requiresAuth: true },
  },
];
